var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2360_3080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 28.4375C22.4213 28.4375 28.4375 22.4213 28.4375 15C28.4375 7.57868 22.4213 1.5625 15 1.5625C7.57868 1.5625 1.5625 7.57868 1.5625 15C1.5625 22.4213 7.57868 28.4375 15 28.4375Z",
    fill: "#79EE8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 15C3.125 8.44163 8.44163 3.125 15 3.125C21.5584 3.125 26.875 8.44163 26.875 15C26.875 21.5584 21.5584 26.875 15 26.875C8.44163 26.875 3.125 21.5584 3.125 15ZM15 0C6.71572 0 0 6.71572 0 15C0 23.2843 6.71572 30 15 30C18.0115 30 20.8158 29.1125 23.1654 27.5848L29.6655 34.085C30.8858 35.3052 32.8645 35.3052 34.085 34.085C35.3052 32.8645 35.3052 30.8858 34.085 29.6655L27.5848 23.1654C29.1125 20.8158 30 18.0115 30 15C30 6.71572 23.2843 0 15 0Z",
    fill: "#0C098C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2360_3080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/MagnifyingGlass.c2ad80b5ca9a1c1c14f92f8a27b44c46.svg";
export { ForwardRef as ReactComponent };